import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPrioritiesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-priorities',
	path: '/jira/settings/issues/priorities',
};
